export type CountdownParts = {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number) => String(value).padStart(2, '0')

/**
 * Splits the remaining milliseconds into zero-padded hours, minutes and seconds.
 *
 * No days segment: the countdown only shows inside the last 24 hours of a promotion, so hours
 * never exceeds 23. Rounds down, the way a clock counting to zero should.
 */
export const formatCountdown = (remainingMs: number): CountdownParts => {
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000))

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
  }
}
